import { getSavedItemCountNum } from '@/redux/modules/savedItemCount';
import { useAppSelector } from '@/redux/hooks';
import ItemBiddingSaveButton from '@/components/ItemBidding/ItemBiddingSaveButton';
import React, { ReactNode } from 'react';
import styled from 'styled-components';

export type BiddingBoxProps = {
    children: ReactNode;
    itemId: number;
};

const BiddingBox = ({ children, itemId }: BiddingBoxProps) => {
    const savedCount = useAppSelector((state) => getSavedItemCountNum(state, itemId));

    const showLowerContainer = savedCount > 0;

    return (
        <StyledBox>
            {children}
            {showLowerContainer && (
                <LowerContainer>
                    <ItemBiddingSaveButton itemId={itemId} />
                </LowerContainer>
            )}
        </StyledBox>
    );
};

export default BiddingBox;

const StyledBox = styled.section`
    background: ${({ theme }) => theme.colors.beige100};
    border: 1px solid ${({ theme }) => theme.colors.grey400};
    display: flex;
    flex-direction: column;
    margin-top: 8px;
    @media (max-width: ${({ theme }) => theme.breakpoints.tabletNarrowWidth}) {
        margin-top: 16px;
    }
    opacity: 1;
    transition: opacity 0.1s ease-in;
    @media print {
        border: none;
        margin: 0;
    }
`;

const LowerContainer = styled.div`
    white-space: nowrap;
    padding: 0 32px 32px 32px;
    // Keeping the bidder watch count on this component is more DRY,
    // but there are many possible components for the children prop.
    // If/When we have better architecture around this bidding box,
    // we should remove this negative margin then.
    margin-top: -24px;

    @media (max-width: ${({ theme }) => theme.breakpoints.tabletNarrowWidth}) {
        padding: 0 16px 16px 16px;
        margin-top: 0;
    }
`;
